(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sereni-description-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("sereni-description-links")) {
    class SereniDescriptionLinks extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.controller = new AbortController();
        this.frame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
      }

      initialize() {
        const description = this.nextElementSibling;
        const nav = this.querySelector("nav");
        if (!description?.classList.contains("prose") || !nav) return;

        const headings = [...description.querySelectorAll("h2, h3, h4")];
        const definitions = [
          { key: "specifications", names: ["製品仕様"], label: this.dataset.specificationsLabel },
          { key: "washing", names: ["洗濯方法", "お手入れ方法", "洗濯・お手入れ", "お手入れ"], label: this.dataset.washingLabel },
          { key: "faq", names: ["よくあるご質問"], label: this.dataset.faqLabel }
        ];

        this.targets = new Map();
        nav.replaceChildren();

        for (const definition of definitions) {
          const target = headings.find((heading) => definition.names.includes(heading.textContent.replace(/\s+/g, "").trim()));
          if (!target) continue;

          if (!target.id) {
            const base = this.dataset.targetPrefix + "-" + definition.key;
            let id = base;
            let suffix = 2;
            while (document.getElementById(id)) id = base + "-" + suffix++;
            target.id = id;
          }

          target.classList.add("sereni-description-jump-target");
          if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");

          const link = document.createElement("a");
          link.href = "#" + encodeURIComponent(target.id);
          link.setAttribute("allow-hash-change", "");
          link.textContent = definition.label;
          nav.append(link);
          this.targets.set(target.id, target);
        }

        this.hidden = this.targets.size === 0;
        if (this.hidden) return;

        nav.addEventListener("click", (event) => {
          const link = event.target.closest("a");
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = this.targetForHash(link.hash);
          if (target) {
            this.lastLink = link;
            target.focus({ preventScroll: true });
          }
        }, { signal: this.controller.signal });

        window.addEventListener("hashchange", () => {
          const target = this.targetForHash(location.hash);
          if (target) this.alignTarget(target);
          else if (!location.hash && this.lastLink?.isConnected && [...this.targets.values()].includes(document.activeElement)) this.lastLink.focus({ preventScroll: true });
        }, { signal: this.controller.signal });

        const initialTarget = this.targetForHash(location.hash);
        if (initialTarget) {
          const alignInitial = () => {
            if (this.targetForHash(location.hash) === initialTarget) this.alignTarget(initialTarget);
          };
          if (document.readyState === "complete") alignInitial();
          else window.addEventListener("load", alignInitial, { once: true, signal: this.controller.signal });
        }
      }

      alignTarget(target) {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected || !target.isConnected) return;
          target.scrollIntoView({ block: "start", behavior: "instant" });
          target.focus({ preventScroll: true });
        });
      }

      targetForHash(hash) {
        try {
          return this.targets?.get(decodeURIComponent(hash.slice(1)));
        } catch {
          return undefined;
        }
      }
    }

    customElements.define("sereni-description-links", SereniDescriptionLinks);
  }
  } catch(e) { console.error(e); }
})();

})();
